var Opal = require('../opal').default; /* Generated by Opal 0.11.99.dev */
(function(Opal) {
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_divide(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs / rhs : lhs['$/'](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  function $rb_lt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs < rhs : lhs['$<'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $truthy = Opal.truthy, $gvars = Opal.gvars;

  Opal.add_stubs(['$setPrefixes', '$debug', '$===', '$to_i', '$getDiceType', '$==', '$parren_killer', '$+', '$getDiffculty', '$getRollValue', '$getResultText', '$empty?', '$getModifyString', '$getBaseText', '$!=', '$isValidDiceOne', '$isValidDice', '$/', '$%', '$include?', '$nil?', '$rand', '$isFamble', '$isCritical', '$>=', '$>', '$to_s', '$<']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'Ryutama');

    var $nesting = [self].concat($parent_nesting), $Ryutama_initialize$1, $Ryutama_gameName$2, $Ryutama_gameType$3, $Ryutama_getHelpMessage$4, $Ryutama_rollDiceCommand$5, $Ryutama_getDiceType$6, $Ryutama_isValidDice$7, $Ryutama_isValidDiceOne$8, $Ryutama_getDiffculty$9, $Ryutama_getRollValue$10, $Ryutama_getResultText$11, $Ryutama_isFamble$12, $Ryutama_isCritical$13, $Ryutama_getBaseText$14, $Ryutama_getModifyString$15;

    self.$$prototype.validDiceTypes = nil;
    
    self.$setPrefixes(["R\\d+.*"]);
    
    Opal.def(self, '$initialize', $Ryutama_initialize$1 = function $$initialize() {
      var $iter = $Ryutama_initialize$1.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

      if ($iter) $Ryutama_initialize$1.$$p = null;
      // Prepare super implicit arguments
      for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
        $zuper[$zuper_i] = arguments[$zuper_i];
      }
      
      $send(self, Opal.find_super_dispatcher(self, 'initialize', $Ryutama_initialize$1, false), $zuper, $iter);
      return (self.validDiceTypes = [20, 12, 10, 8, 6, 4, 2]);
    }, $Ryutama_initialize$1.$$arity = 0);
    
    Opal.def(self, '$gameName', $Ryutama_gameName$2 = function $$gameName() {
      var self = this;

      return "りゅうたま"
    }, $Ryutama_gameName$2.$$arity = 0);
    
    Opal.def(self, '$gameType', $Ryutama_gameType$3 = function $$gameType() {
      var self = this;

      return "Ryutama"
    }, $Ryutama_gameType$3.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $Ryutama_getHelpMessage$4 = function $$getHelpMessage() {
      var self = this;

      return "" + "・判定\n" + "　Rx,y>=t（x,y：使用する能力値、t：目標値）\n" + "　1ゾロ、クリティカルも含めて判定結果を表示します\n" + "　能力値１つでの判定は Rx>=t で行えます\n" + "例）R8,6>=13\n"
    }, $Ryutama_getHelpMessage$4.$$arity = 0);
    
    Opal.def(self, '$rollDiceCommand', $Ryutama_rollDiceCommand$5 = function $$rollDiceCommand(command) {
      var $a, $b, self = this, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil, dice1 = nil, dice2 = nil, modifyString = nil, difficulty = nil, modify = nil, value1 = nil, value2 = nil, total = nil, result = nil, value1Text = nil, value2Text = nil, modifyText = nil, baseText = nil, output = nil;

      
      self.$debug("rollDiceCommand begin");
      if ($truthy(/^R(\d+)(,(\d+))?([\+\-\d]+)?(>=(\d+))?/['$==='](command))) {
      } else {
        
        self.$debug("unmatched!");
        return "";
      };
      __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
      __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
      __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
      __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
      __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
      __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
      __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
      __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
      __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
      __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
      __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
      __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
      __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
      __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
      __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
      __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
      __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
      __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
      __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
      __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
      self.$debug("matched");
      dice1 = __last__match__1.$to_i();
      dice2 = __last__match__3.$to_i();
      modifyString = __last__match__4;
      difficulty = __last__match__6;
      $b = self.$getDiceType(dice1, dice2), $a = Opal.to_ary($b), (dice1 = ($a[0] == null ? nil : $a[0])), (dice2 = ($a[1] == null ? nil : $a[1])), $b;
      if ($truthy(dice1['$=='](0))) {
        return ""};
      modifyString = ($truthy($a = modifyString) ? $a : "");
      modify = self.$parren_killer($rb_plus($rb_plus("(", modifyString), ")")).$to_i();
      difficulty = self.$getDiffculty(difficulty);
      value1 = self.$getRollValue(dice1);
      value2 = self.$getRollValue(dice2);
      total = $rb_plus($rb_plus(value1, value2), modify);
      result = self.$getResultText(value1, value2, dice1, dice2, difficulty, total);
      if ($truthy(result['$empty?']())) {
      } else {
        result = "" + " ＞ " + (result)
      };
      value1Text = "" + (value1) + "(" + (dice1) + ")";
      value2Text = (function() {if ($truthy(value2['$=='](0))) {
        return ""
      } else {
        return "" + "+" + (value2) + "(" + (dice2) + ")"
      }; return nil; })();
      modifyText = self.$getModifyString(modify);
      baseText = self.$getBaseText(dice1, dice2, modify, difficulty);
      output = "" + "(" + (baseText) + ") ＞ " + (value1Text) + (value2Text) + (modifyText) + " ＞ " + (total) + (result);
      return output;
    }, $Ryutama_rollDiceCommand$5.$$arity = 1);
    
    Opal.def(self, '$getDiceType', $Ryutama_getDiceType$6 = function $$getDiceType(dice1, dice2) {
      var self = this, diceBase = nil;

      
      self.$debug("getDiceType begin");
      if ($truthy(dice2['$!='](0))) {
        if ($truthy(self.$isValidDiceOne(dice1))) {
          return [dice1, dice2]
        } else {
          return [0, 0]
        }};
      if ($truthy(self.$isValidDice(dice1, dice2))) {
        return [dice1, dice2]};
      diceBase = dice1;
      dice1 = $rb_divide(diceBase, 10);
      dice2 = diceBase['$%'](10);
      if ($truthy(self.$isValidDice(dice1, dice2))) {
        return [dice1, dice2]};
      dice1 = $rb_divide(diceBase, 100);
      dice2 = diceBase['$%'](100);
      if ($truthy(self.$isValidDice(dice1, dice2))) {
        return [dice1, dice2]};
      if ($truthy(self.$isValidDiceOne(diceBase))) {
        return [diceBase, 0]};
      return [0, 0];
    }, $Ryutama_getDiceType$6.$$arity = 2);
    
    Opal.def(self, '$isValidDice', $Ryutama_isValidDice$7 = function $$isValidDice(dice1, dice2) {
      var $a, self = this;

      return ($truthy($a = self.$isValidDiceOne(dice1)) ? self.$isValidDiceOne(dice2) : $a)
    }, $Ryutama_isValidDice$7.$$arity = 2);
    
    Opal.def(self, '$isValidDiceOne', $Ryutama_isValidDiceOne$8 = function $$isValidDiceOne(dice) {
      var self = this;

      return self.validDiceTypes['$include?'](dice)
    }, $Ryutama_isValidDiceOne$8.$$arity = 1);
    
    Opal.def(self, '$getDiffculty', $Ryutama_getDiffculty$9 = function $$getDiffculty(difficulty) {
      var self = this;

      
      if ($truthy(difficulty['$nil?']())) {
      } else {
        difficulty = difficulty.$to_i()
      };
      return difficulty;
    }, $Ryutama_getDiffculty$9.$$arity = 1);
    
    Opal.def(self, '$getRollValue', $Ryutama_getRollValue$10 = function $$getRollValue(dice) {
      var self = this, value = nil;

      
      if ($truthy(dice['$=='](0))) {
        return 0};
      value = $rb_plus(self.$rand(dice), 1);
      return value;
    }, $Ryutama_getRollValue$10.$$arity = 1);
    
    Opal.def(self, '$getResultText', $Ryutama_getResultText$11 = function $$getResultText(value1, value2, dice1, dice2, difficulty, total) {
      var self = this;

      
      if ($truthy(self.$isFamble(value1, value2))) {
        return "１ゾロ【１ゾロポイント＋１】"};
      if ($truthy(self.$isCritical(value1, value2, dice1, dice2))) {
        return "クリティカル成功"};
      if ($truthy(difficulty['$nil?']())) {
        return ""};
      if ($truthy($rb_ge(total, difficulty))) {
        return "成功"};
      return "失敗";
    }, $Ryutama_getResultText$11.$$arity = 6);
    
    Opal.def(self, '$isFamble', $Ryutama_isFamble$12 = function $$isFamble(value1, value2) {
      var $a, self = this;

      return ($truthy($a = value1['$=='](1)) ? value2['$=='](1) : $a)
    }, $Ryutama_isFamble$12.$$arity = 2);
    
    Opal.def(self, '$isCritical', $Ryutama_isCritical$13 = function $$isCritical(value1, value2, dice1, dice2) {
      var $a, self = this;

      
      if ($truthy(value2['$=='](0))) {
        return false};
      if ($truthy(($truthy($a = value1['$=='](6)) ? value2['$=='](6) : $a))) {
        return true};
      if ($truthy(($truthy($a = value1['$=='](dice1)) ? value2['$=='](dice2) : $a))) {
        return true};
      return false;
    }, $Ryutama_isCritical$13.$$arity = 4);
    
    Opal.def(self, '$getBaseText', $Ryutama_getBaseText$14 = function $$getBaseText(dice1, dice2, modify, difficulty) {
      var self = this, baseText = nil;

      
      baseText = "" + "R" + (dice1);
      if ($truthy(dice2['$!='](0))) {
        baseText = $rb_plus(baseText, "" + "," + (dice2))};
      baseText = $rb_plus(baseText, self.$getModifyString(modify));
      if ($truthy(difficulty['$nil?']())) {
      } else {
        baseText = $rb_plus(baseText, "" + ">=" + (difficulty))
      };
      return baseText;
    }, $Ryutama_getBaseText$14.$$arity = 4);
    return (Opal.def(self, '$getModifyString', $Ryutama_getModifyString$15 = function $$getModifyString(modify) {
      var self = this;

      
      if ($truthy($rb_gt(modify, 0))) {
        return $rb_plus("+", modify.$to_s())
      } else if ($truthy($rb_lt(modify, 0))) {
        return modify.$to_s()};
      return "";
    }, $Ryutama_getModifyString$15.$$arity = 1), nil) && 'getModifyString';
  })($nesting[0], $$($nesting, 'DiceBot'), $nesting)
})(Opal);
